import { ScrollArea } from "@mantine/core";
import React from "react";

import styles from "./ScrollableTable.module.scss";

export const ScrollTableWrapper: React.FC<
  React.ComponentProps<typeof ScrollArea>
> = ({ children, className, ...rest }) => (
  <ScrollArea
    className={`${styles.scrollTableWrapper} ${className ?? ""}`}
    {...(rest as any)}>
    {children}
  </ScrollArea>
);

export const ScrollTablePageWrapper: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.scrollTablePageWrapper} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const ScrollTableHead: React.FC<
  React.HTMLAttributes<HTMLTableSectionElement> & { pageSticky?: boolean }
> = ({ children, className, pageSticky, ...rest }) => (
  <thead
    className={`${pageSticky ? styles.scrollTableHeadPageSticky : styles.scrollTableHead} ${className ?? ""}`}
    {...rest}>
    {children}
  </thead>
);

export const ScrollTableBody: React.FC<
  React.HTMLAttributes<HTMLTableSectionElement>
> = ({ children, className, ...rest }) => (
  <tbody className={`${styles.scrollTableBody} ${className ?? ""}`} {...rest}>
    {children}
  </tbody>
);
